/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'broadcast-solid': {
    width: 16,
    height: 16,
    viewBox: '0 0 25 25',
    data: '<path pid="0" d="M14 13.5a.5.5 0 1 1-1 0V9H6a5 5 0 1 0 0 10h1v4.5a1.5 1.5 0 0 0 1.794 1.47l1.815-.363a1.5 1.5 0 0 0 1.19-1.683L11.24 19H15V9h-1zM22.223 4.085L16 8.635v10.73l6.223 4.55A.5.5 0 0 0 23 23.5V4.501a.5.5 0 0 0-.777-.416z"/>'
  }
})
